// extracted by mini-css-extract-plugin
export default {"flagRow":"PartnerFlagsModal_flagRow__VcQwl","button":"PartnerFlagsModal_button__Yq4+C","buttons":"PartnerFlagsModal_buttons__FqCYr"};